import * as LabelPrimitive from "@radix-ui/react-label";
import * as React from "react";
import { cn } from "@/shared/lib/utils";

export const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn("text-[13px] font-semibold text-ink", className)}
    {...props}
  />
));
Label.displayName = "Label";
